import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../config/api';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      toast.error('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const response = await requestPasswordReset(email);
      
      if (response.success) {
        setEmailSent(true);
        toast.success('Password reset link sent to your email!');
      } else {
        toast.error(response.message || 'Failed to send reset link');
      }
    } catch (error) {
      console.error('Error requesting password reset:', error);
      toast.error('Failed to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ 
              fontSize: '48px', 
              marginBottom: '16px',
              color: '#198754'
            }}>
              ✓
            </div>
            <h2 className="login-title">Check Your Email</h2>
          </div>

          <div style={{ 
            padding: '16px', 
            backgroundColor: '#d1e7dd', 
            border: '1px solid #badbcc', 
            borderRadius: '6px',
            marginBottom: '24px',
            color: '#0f5132'
          }}>
            <p style={{ margin: '0 0 12px 0', fontWeight: '500' }}>
              We've sent a password reset link to:
            </p>
            <p style={{ margin: '0', fontWeight: '600', fontSize: '16px' }}>
              {email}
            </p>
          </div>

          <div style={{ 
            padding: '16px', 
            backgroundColor: '#e7f3ff', 
            border: '1px solid #b3d9ff', 
            borderRadius: '6px',
            marginBottom: '24px',
            fontSize: '14px',
            color: '#0056b3'
          }}>
            <p style={{ margin: '0 0 8px 0', fontWeight: '600' }}>
              📧 Next Steps:
            </p>
            <ol style={{ margin: '0', paddingLeft: '20px' }}>
              <li>Check your email inbox</li>
              <li>Click the password reset link</li>
              <li>Enter your new password</li>
              <li>Login with your new password</li>
            </ol>
          </div>

          <div style={{ 
            padding: '12px', 
            backgroundColor: '#fff3cd', 
            border: '1px solid #ffeaa7', 
            borderRadius: '6px',
            marginBottom: '24px',
            fontSize: '13px',
            color: '#856404'
          }}>
            <strong>⚠️ Note:</strong> The reset link will expire in 1 hour for security reasons.
            If you don't see the email, check your spam folder.
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button
              onClick={() => {
                setEmailSent(false);
                setEmail('');
              }}
              className="btn btn-secondary"
              style={{ width: '100%' }}
            >
              Send to Different Email
            </button>
            
            <Link to="/login" className="btn btn-primary" style={{ width: '100%', textAlign: 'center' }}>
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            fontSize: '48px', 
            marginBottom: '16px',
            color: '#0d6efd'
          }}>
            🔒
          </div>
          <h2 className="login-title">Forgot Password?</h2>
          <p style={{ color: '#6c757d', fontSize: '14px', marginTop: '8px' }}>
            No worries! Enter your email and we'll send you a reset link.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your registered email"
              autoComplete="email"
              inputMode="email"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              autoFocus
            />
            <small style={{ color: '#6c757d', fontSize: '12px', display: 'block', marginTop: '6px' }}>
              We'll send a password reset link to this email
            </small>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', marginTop: '8px' }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#0d6efd', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Login
          </Link>
        </div>

        <div style={{ 
          marginTop: '24px', 
          padding: '12px', 
          backgroundColor: '#f8f9fa', 
          border: '1px solid #e9ecef', 
          borderRadius: '6px',
          fontSize: '13px',
          color: '#495057'
        }}>
          <strong>💡 Tip:</strong> Make sure to use the email address you registered with.
          If you continue to have issues, contact support.
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
